import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {OnboardingStepsProgress} from 'pages/Auth/components/OnboardingStepsProgress';
import {AuthPageHeader} from 'pages/Auth/components/AuthPage';

export const Wrapper = styled.div`
  padding: 40px 24px;

  @media (min-width: ${DEVICE.laptop}) {
    padding: 0 40px;
  }
`;

export const Container = styled.div`
  max-width: 522px;
  margin: 0 auto;
`;

export const StyledHeader = styled(AuthPageHeader)`
  margin-bottom: 0;
  height: 80px;
`;

export const StyledOnboardingStepsProgress = styled(OnboardingStepsProgress)`
  margin-bottom: 24px;

  @media (min-width: ${DEVICE.laptop}) {
    margin-bottom: 48px;
  }
`;
